import { Chip, ChipProps } from "@bvhi/ui-base";

interface Props extends Omit<ChipProps, "color" | "label"> {
  value: boolean;
  trueLabel: string;
  falseLabel: string;
}

export function BooleanChip({ value, trueLabel, falseLabel, size = "small", ...chipProps }: Props) {
  return <Chip color={value ? "success" : "error"} label={value ? trueLabel : falseLabel} size={size} {...chipProps} />;
}
